var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.grades.REPORT_OPTIONS !== undefined
    ? _c(
        "section",
        {
          staticClass: "class-page grades-breakdown",
          staticStyle: { padding: "15px" },
          attrs: { id: "classPage" }
        },
        [
          _c("class-page-header", {
            attrs: {
              details: _vm.details,
              "current-section": 0,
              course: _vm.course,
              menu: _vm.menu,
              "is-class-item-page": true
            }
          }),
          _vm._v(" "),
          _c("div", { staticClass: "back-link" }, [
            _c(
              "a",
              {
                staticStyle: { cursor: "pointer" },
                on: {
                  click: function($event) {
                    return _vm.goToClassPage()
                  }
                }
              },
              [
                _c("i", {
                  staticClass: "fas fa-caret-left",
                  attrs: { "aria-hidden": "true" }
                }),
                _vm._v(
                  _vm._s(_vm.$t("MAIN_CONTENT.commonContent.goBack")) + "\n\t\t"
                )
              ]
            )
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "class-page-body" }, [
            _vm.grades.CURRENT_GRADE !== undefined
              ? _c("div", { staticClass: "col-md-12 overview-top" }, [
                  _c("div", { staticClass: "col-md-6 col-sm-12" }, [
                    _c("h2", [
                      _vm._v(
                        "\n\t\t\t\t\t" +
                          _vm._s(
                            _vm.$t("MAIN_CONTENT.ClassGrades.markingPeriod", {
                              code: _vm.mpCode
                            })
                          ) +
                          "\n\t\t\t\t"
                      )
                    ])
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "col-md-3 col-sm-6" }, [
                    _c("label", [
                      _vm._v(
                        "\n\t\t\t\t\t" +
                          _vm._s(
                            _vm.$t("MAIN_CONTENT.ClassGrades.currentGrade")
                          ) +
                          "\n\t\t\t\t"
                      )
                    ]),
                    _vm._v(" "),
                    _c("p", [
                      _vm._v(
                        "\n\t\t\t\t\t" +
                          _vm._s(
                            _vm.grades.REPORT_OPTIONS.SHOW_PERCENT_FLG ===
                              "Y" && _vm.grades.CURRENT_GRADE.PERCENT !== ""
                              ? _vm.grades.CURRENT_GRADE.PERCENT + "%"
                              : ""
                          ) +
                          "\n\t\t\t\t\t" +
                          _vm._s(
                            _vm.grades.REPORT_OPTIONS.SHOW_LETTER_FLG === "Y" &&
                              _vm.grades.CURRENT_GRADE.LETTER !== ""
                              ? _vm.grades.CURRENT_GRADE.LETTER
                              : ""
                          ) +
                          "\n\t\t\t\t"
                      )
                    ])
                  ]),
                  _vm._v(" "),
                  _vm.grades.REPORT_OPTIONS.SHOW_POINTS_FLG === "Y"
                    ? _c("div", { staticClass: "col-md-3 col-sm-6" }, [
                        _c("label", [
                          _vm._v(
                            "\n\t\t\t\t\t" +
                              _vm._s(
                                _vm.$t("MAIN_CONTENT.ClassGrades.points")
                              ) +
                              "\n\t\t\t\t"
                          )
                        ]),
                        _vm._v(" "),
                        _vm.grades.CURRENT_GRADE.EARNED_POINTS !== "" &&
                        _vm.grades.CURRENT_GRADE.MAX_POINTS !== ""
                          ? _c("p", [
                              _vm._v(
                                "\n\t\t\t\t\t" +
                                  _vm._s(
                                    _vm.$t(
                                      "MAIN_CONTENT.ClassGrades.gradesOverPointsAsterisk",
                                      {
                                        grade:
                                          _vm.grades.CURRENT_GRADE
                                            .EARNED_POINTS,
                                        points:
                                          _vm.grades.CURRENT_GRADE.MAX_POINTS
                                      }
                                    )
                                  ) +
                                  "\n\t\t\t\t"
                              )
                            ])
                          : _vm._e()
                      ])
                    : _vm._e()
                ])
              : _vm._e(),
            _vm._v(" "),
            _c("div", [
              _c("small", [
                _vm._v(
                  _vm._s(_vm.$t("MAIN_CONTENT.ClassGrades.finalAverageNote"))
                )
              ])
            ]),
            _vm._v(" "),
            _vm.grades.REPORT_OPTIONS.SHOW_STUDENT_GRADE_CATEGORY_SUB_FLG ===
            "Y"
              ? _c("div", { staticClass: "mb-2" }, [
                  _c("h3", [
                    _vm._v(
                      _vm._s(_vm.$t("MAIN_CONTENT.ClassGrades.categories"))
                    )
                  ]),
                  _vm._v(" "),
                  _vm.grades.CATEGORIES.length === 0
                    ? _c("p", [
                        _c("i", [
                          _vm._v(
                            _vm._s(
                              _vm.$t(
                                "MAIN_CONTENT.ClassGrades.noCategoryGrades"
                              )
                            )
                          )
                        ])
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.grades.CATEGORIES.length > 0
                    ? _c(
                        "div",
                        { staticClass: "flex-container" },
                        _vm._l(_vm.grades.CATEGORIES, function(category) {
                          return _c(
                            "div",
                            {
                              key: "category-" + category.CATEGORY_CODE,
                              staticClass: "panel-body panel-body-table"
                            },
                            [
                              _c("table", { staticClass: "table table-box" }, [
                                _c("thead", [
                                  _c("tr", [
                                    _c("th", { attrs: { colspan: "2" } }, [
                                      _vm._v(
                                        "\n\t\t\t\t\t\t\t\t\t" +
                                          _vm._s(category.CATEGORY_NAME) +
                                          "\n\t\t\t\t\t\t\t\t"
                                      )
                                    ])
                                  ])
                                ]),
                                _vm._v(" "),
                                _c(
                                  "tbody",
                                  [
                                    [
                                      _vm.grades.REPORT_OPTIONS
                                        .SHOW_PERCENT_FLG === "Y" ||
                                      _vm.grades.REPORT_OPTIONS
                                        .SHOW_LETTER_FLG === "Y"
                                        ? _c("tr", [
                                            _c("th", [
                                              _vm._v(
                                                "\n\t\t\t\t\t\t\t\t\t\t" +
                                                  _vm._s(
                                                    _vm.$t(
                                                      "MAIN_CONTENT.ClassGrades.grade"
                                                    )
                                                  ) +
                                                  "\n\t\t\t\t\t\t\t\t\t"
                                              )
                                            ]),
                                            _vm._v(" "),
                                            _c(
                                              "td",
                                              [
                                                _vm.grades.REPORT_OPTIONS
                                                  .SHOW_PERCENT_FLG === "Y"
                                                  ? [
                                                      _vm._v(
                                                        "\n\t\t\t\t\t\t\t\t\t\t\t" +
                                                          _vm._s(
                                                            _vm.$t(
                                                              "MAIN_CONTENT.ClassGrades.percent",
                                                              {
                                                                percent:
                                                                  category.CURRENT_PERCENT
                                                              }
                                                            )
                                                          ) +
                                                          " \n\t\t\t\t\t\t\t\t\t\t"
                                                      )
                                                    ]
                                                  : _vm._e(),
                                                _vm._v(" "),
                                                _vm.grades.REPORT_OPTIONS
                                                  .SHOW_LETTER_FLG === "Y"
                                                  ? [
                                                      _vm._v(
                                                        "\n\t\t\t\t\t\t\t\t\t\t\t" +
                                                          _vm._s(
                                                            category.CATEGORY_GRADE_LETTER
                                                          ) +
                                                          "\n\t\t\t\t\t\t\t\t\t\t"
                                                      )
                                                    ]
                                                  : _vm._e()
                                              ],
                                              2
                                            )
                                          ])
                                        : _vm._e(),
                                      _vm._v(" "),
                                      _vm.grades.REPORT_OPTIONS
                                        .SHOW_POINTS_FLG === "Y"
                                        ? _c("tr", [
                                            _c("th", [
                                              _vm._v(
                                                "\n\t\t\t\t\t\t\t\t\t\t" +
                                                  _vm._s(
                                                    _vm.$t(
                                                      "MAIN_CONTENT.ClassGrades.points"
                                                    )
                                                  ) +
                                                  "\n\t\t\t\t\t\t\t\t\t"
                                              )
                                            ]),
                                            _vm._v(" "),
                                            _c("td", [
                                              _vm._v(
                                                "\n\t\t\t\t\t\t\t\t\t\t" +
                                                  _vm._s(
                                                    _vm.$t(
                                                      "MAIN_CONTENT.ClassGrades.currentOverMaxPoints",
                                                      {
                                                        current:
                                                          category.PWP_CURRENT_POINTS,
                                                        max:
                                                          category.PWP_MAX_POINTS
                                                      }
                                                    )
                                                  ) +
                                                  "\n\t\t\t\t\t\t\t\t\t"
                                              )
                                            ])
                                          ])
                                        : _vm._e(),
                                      _vm._v(" "),
                                      _vm.grades.REPORT_OPTIONS
                                        .SHOW_STUDENT_GRADE_ASSIGNMENT_NUM_FLG ===
                                      "Y"
                                        ? _c("tr", [
                                            _c("th", [
                                              _vm._v(
                                                "\n\t\t\t\t\t\t\t\t\t\t" +
                                                  _vm._s(
                                                    _vm.$t(
                                                      "MAIN_CONTENT.ClassGrades.assignments"
                                                    )
                                                  ) +
                                                  "\n\t\t\t\t\t\t\t\t\t"
                                              )
                                            ]),
                                            _vm._v(" "),
                                            _c("td", [
                                              _vm._v(
                                                "\n\t\t\t\t\t\t\t\t\t\t" +
                                                  _vm._s(
                                                    category.ASSIGNMENT_COUNT
                                                  ) +
                                                  "\n\t\t\t\t\t\t\t\t\t"
                                              )
                                            ])
                                          ])
                                        : _vm._e(),
                                      _vm._v(" "),
                                      _vm.grades.REPORT_OPTIONS
                                        .SHOW_CATEGORY_WEIGHT_FLG === "Y"
                                        ? _c("tr", [
                                            _c("th", [
                                              _vm._v(
                                                "\n\t\t\t\t\t\t\t\t\t\t" +
                                                  _vm._s(
                                                    _vm.$t(
                                                      "MAIN_CONTENT.ClassGrades.weight"
                                                    )
                                                  ) +
                                                  "\n\t\t\t\t\t\t\t\t\t"
                                              )
                                            ]),
                                            _vm._v(" "),
                                            _c("td", [
                                              _vm._v(
                                                "\n\t\t\t\t\t\t\t\t\t\t" +
                                                  _vm._s(
                                                    parseFloat(
                                                      category.WEIGHT
                                                    ).toFixed(
                                                      _vm.grades.REPORT_OPTIONS
                                                        .NO_OF_DECIMAL_PLACES
                                                    )
                                                  ) +
                                                  "\n\t\t\t\t\t\t\t\t\t"
                                              )
                                            ])
                                          ])
                                        : _vm._e(),
                                      _vm._v(" "),
                                      _vm.grades.REPORT_OPTIONS
                                        .SHOW_CATEGORY_PERCENT_FLG === "Y"
                                        ? _c("tr", [
                                            _c("th", [
                                              _vm._v(
                                                "\n\t\t\t\t\t\t\t\t\t\t" +
                                                  _vm._s(
                                                    _vm.$t(
                                                      "MAIN_CONTENT.ClassGrades.markingPeriodAbbreviation"
                                                    )
                                                  ) +
                                                  "\n\t\t\t\t\t\t\t\t\t"
                                              )
                                            ]),
                                            _vm._v(" "),
                                            _c("td", [
                                              _vm._v(
                                                "\n\t\t\t\t\t\t\t\t\t\t" +
                                                  _vm._s(
                                                    category.PERCENT_OF_TOTAL &&
                                                      category.PERCENT_OF_TOTAL !=
                                                        0
                                                      ? parseFloat(
                                                          category.PERCENT_OF_TOTAL
                                                        ).toFixed(
                                                          _vm.grades
                                                            .REPORT_OPTIONS
                                                            .NO_OF_DECIMAL_PLACES
                                                        ) + "%"
                                                      : ""
                                                  ) +
                                                  "\n\t\t\t\t\t\t\t\t\t"
                                              )
                                            ])
                                          ])
                                        : _vm._e()
                                    ]
                                  ],
                                  2
                                )
                              ])
                            ]
                          )
                        }),
                        0
                      )
                    : _vm._e()
                ])
              : _vm._e(),
            _vm._v(" "),
            _c("div", { staticClass: "assignments" }, [
              _c("div", { staticClass: "mb-1" }, [
                _c("div", { staticClass: "row" }, [
                  _c("div", { staticClass: "col-xs-12 col-md-6" }, [
                    _c(
                      "h3",
                      {
                        directives: [
                          {
                            name: "tooltip",
                            rawName: "v-tooltip.top-center",
                            value: {
                              content: _vm.assignmentsTooltip(),
                              trigger: "hover click"
                            },
                            expression:
                              "{content: assignmentsTooltip(), trigger: 'hover click'}",
                            modifiers: { "top-center": true }
                          }
                        ]
                      },
                      [
                        _vm._v(
                          "\n\t\t\t\t\t\t\t" +
                            _vm._s(
                              _vm.$t(
                                "MAIN_CONTENT.ClassGrades.assignmentsAllCaps"
                              )
                            ) +
                            " "
                        ),
                        _c("i", { staticClass: "fas fa-question-circle" })
                      ]
                    )
                  ]),
                  _vm._v(" "),
                  _vm.grades.ASSIGNMENTS.length > 0
                    ? _c(
                        "div",
                        { staticClass: "col-xs-12 col-md-6 float-right" },
                        [
                          _c("label", { attrs: { for: "filter" } }, [
                            _vm._v(
                              "\n\t\t\t\t\t\t\t" +
                                _vm._s(
                                  _vm.$t("MAIN_CONTENT.ClassGrades.showBy")
                                ) +
                                "\n\t\t\t\t\t\t"
                            )
                          ]),
                          _vm._v(" "),
                          _c(
                            "select",
                            {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.show,
                                  expression: "show"
                                }
                              ],
                              attrs: { name: "filter", id: "filter" },
                              on: {
                                change: function($event) {
                                  var $$selectedVal = Array.prototype.filter
                                    .call($event.target.options, function(o) {
                                      return o.selected
                                    })
                                    .map(function(o) {
                                      var val =
                                        "_value" in o ? o._value : o.value
                                      return val
                                    })
                                  _vm.show = $event.target.multiple
                                    ? $$selectedVal
                                    : $$selectedVal[0]
                                }
                              }
                            },
                            [
                              _c("option", { attrs: { value: "date" } }, [
                                _vm._v(
                                  "\n\t\t\t\t\t\t\t\t" +
                                    _vm._s(
                                      _vm.$t("MAIN_CONTENT.ClassGrades.date")
                                    ) +
                                    "\n\t\t\t\t\t\t\t"
                                )
                              ]),
                              _vm._v(" "),
                              _c("option", { attrs: { value: "category" } }, [
                                _vm._v(
                                  "\n\t\t\t\t\t\t\t\t" +
                                    _vm._s(
                                      _vm.$t(
                                        "MAIN_CONTENT.ClassGrades.category"
                                      )
                                    ) +
                                    "\n\t\t\t\t\t\t\t"
                                )
                              ])
                            ]
                          )
                        ]
                      )
                    : _vm._e()
                ])
              ]),
              _vm._v(" "),
              _vm.grades.ASSIGNMENTS.length === 0
                ? _c("p", [
                    _c("i", [
                      _vm._v(
                        " " +
                          _vm._s(
                            _vm.$t(
                              "MAIN_CONTENT.ClassGrades.noAssignmentGrades"
                            )
                          )
                      )
                    ])
                  ])
                : _vm._e(),
              _vm._v(" "),
              _vm.show === "date"
                ? _c(
                    "div",
                    { staticClass: "display-table by-date mb-1" },
                    [
                      _vm._l(_vm.assignmentsByDate(), function(assignment) {
                        return [
                          _c(
                            "div",
                            {
                              key:
                                assignment.ASSIGNMENT_CATEGORY_CODE +
                                "-" +
                                assignment.ASSIGNMENT_CODE,
                              staticClass: "display-container"
                            },
                            [
                              _c("div", { staticClass: "header col-xs-12" }, [
                                _c(
                                  "div",
                                  { staticClass: "col-xs-12 col-sm-6" },
                                  [
                                    _c("h4", [
                                      _c("strong", [
                                        _vm._v(
                                          _vm._s(assignment.ASSIGNMENT_NAME)
                                        )
                                      ]),
                                      _vm._v(" "),
                                      _vm.grades.REPORT_OPTIONS
                                        .SHOW_CATEGORIES_FLG === "Y"
                                        ? _c("span", [
                                            _vm._v(
                                              "- " +
                                                _vm._s(assignment.CATEGORY_NAME)
                                            )
                                          ])
                                        : _vm._e()
                                    ])
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  {
                                    staticClass: "col-xs-12 col-sm-6",
                                    staticStyle: { "min-height": "25px" }
                                  },
                                  [
                                    _c(
                                      "div",
                                      { staticClass: "score-pill float-right" },
                                      [
                                        !!_vm.gradeMappings[
                                          assignment.GRADE_CODE.toString().toUpperCase()
                                        ]
                                          ? _c(
                                              "span",
                                              {
                                                directives: [
                                                  {
                                                    name: "tooltip",
                                                    rawName:
                                                      "v-tooltip.top-center",
                                                    value: {
                                                      content: _vm.assignmentsTooltip(
                                                        assignment.GRADE_CODE
                                                      ),
                                                      trigger: "hover click"
                                                    },
                                                    expression:
                                                      "{content: assignmentsTooltip(assignment.GRADE_CODE), trigger: 'hover click'}",
                                                    modifiers: {
                                                      "top-center": true
                                                    }
                                                  }
                                                ]
                                              },
                                              [
                                                _c("i", {
                                                  staticClass:
                                                    "fas fa-question-circle"
                                                })
                                              ]
                                            )
                                          : _vm._e(),
                                        _vm._v(
                                          "\n\t\t\t\t\t\t\t\t\t" +
                                            _vm._s(
                                              _vm.$t(
                                                "MAIN_CONTENT.commonContent.score"
                                              )
                                            ) +
                                            " \n\t\t\t\t\t\t\t\t\t"
                                        ),
                                        _c(
                                          "strong",
                                          [
                                            _vm.grades.REPORT_OPTIONS
                                              .SHOW_STUDENT_GRADE_PERCENT_FLG ===
                                            "Y"
                                              ? [
                                                  _vm._v(
                                                    "\n\t\t\t\t\t\t\t\t\t\t\t" +
                                                      _vm._s(
                                                        _vm.$t(
                                                          "MAIN_CONTENT.ClassGrades.codeOverPointsPercent",
                                                          {
                                                            code:
                                                              assignment.GRADE_CODE,
                                                            points:
                                                              assignment.MAX_POINTS,
                                                            percent:
                                                              assignment.GRADE_PERCENT
                                                          }
                                                        )
                                                      ) +
                                                      "\n\t\t\t\t\t\t\t\t\t\t"
                                                  )
                                                ]
                                              : [
                                                  _vm._v(
                                                    "\n\t\t\t\t\t\t\t\t\t\t\t" +
                                                      _vm._s(
                                                        _vm.$t(
                                                          "MAIN_CONTENT.ClassGrades.codeOverPoints",
                                                          {
                                                            code:
                                                              assignment.GRADE_CODE,
                                                            points:
                                                              assignment.MAX_POINTS
                                                          }
                                                        )
                                                      ) +
                                                      "\n\t\t\t\t\t\t\t\t\t\t"
                                                  )
                                                ]
                                          ],
                                          2
                                        )
                                      ]
                                    )
                                  ]
                                )
                              ]),
                              _vm._v(" "),
                              _c("div", { staticClass: "details" }, [
                                _c(
                                  "div",
                                  {
                                    staticClass: "grades-details flex-container"
                                  },
                                  [
                                    _vm.grades.REPORT_OPTIONS
                                      .SHOW_EXTRA_CREDIT_FLG === "Y"
                                      ? _c(
                                          "div",
                                          {
                                            staticClass:
                                              "col-xs-6 col-sm-4 col-md-3 col-lg-2 detail-wrapper"
                                          },
                                          [
                                            _c(
                                              "div",
                                              { staticClass: "content" },
                                              [
                                                _c("dt", [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.$t(
                                                        "MAIN_CONTENT.ClassGrades.maxExtraCredit"
                                                      )
                                                    )
                                                  )
                                                ]),
                                                _vm._v(" "),
                                                _c("dd", [
                                                  _vm._v(
                                                    _vm._s(
                                                      assignment.MAX_EC_POINTS
                                                    )
                                                  )
                                                ])
                                              ]
                                            )
                                          ]
                                        )
                                      : _vm._e(),
                                    _vm._v(" "),
                                    _vm.grades.REPORT_OPTIONS
                                      .SHOW_STUDENT_ASSIGNED_DATE_FLG === "Y"
                                      ? _c(
                                          "div",
                                          {
                                            staticClass:
                                              "col-xs-6 col-sm-4 col-md-3 col-lg-2 detail-wrapper",
                                            class: _vm.dueSoon(
                                              assignment.END_DATE
                                            )
                                              ? "text-danger"
                                              : ""
                                          },
                                          [
                                            _c(
                                              "div",
                                              { staticClass: "content" },
                                              [
                                                _c("dt", [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.$t(
                                                        "MAIN_CONTENT.ClassGrades.dateAssigned"
                                                      )
                                                    )
                                                  )
                                                ]),
                                                _vm._v(" "),
                                                _c("dd", [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm._f("date")(
                                                        assignment.START_DATE
                                                      )
                                                    )
                                                  )
                                                ])
                                              ]
                                            )
                                          ]
                                        )
                                      : _vm._e(),
                                    _vm._v(" "),
                                    _vm.grades.REPORT_OPTIONS
                                      .SHOW_STUDENT_DUE_DATE_FLG === "Y"
                                      ? _c(
                                          "div",
                                          {
                                            staticClass:
                                              "col-xs-6 col-sm-4 col-md-3 col-lg-2 detail-wrapper"
                                          },
                                          [
                                            _c(
                                              "div",
                                              { staticClass: "content" },
                                              [
                                                _c("dt", [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.$t(
                                                        "MAIN_CONTENT.ClassGrades.dateDue"
                                                      )
                                                    )
                                                  )
                                                ]),
                                                _vm._v(" "),
                                                _c("dd", [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm._f("date")(
                                                        assignment.END_DATE
                                                      )
                                                    )
                                                  )
                                                ])
                                              ]
                                            )
                                          ]
                                        )
                                      : _vm._e(),
                                    _vm._v(" "),
                                    _vm.grades.REPORT_OPTIONS
                                      .SHOW_STUDENT_CLASS_AVERAGE_FLG === "Y"
                                      ? _c(
                                          "div",
                                          {
                                            staticClass:
                                              "col-xs-6 col-sm-4 col-md-3 col-lg-2 detail-wrapper"
                                          },
                                          [
                                            _c(
                                              "div",
                                              { staticClass: "content" },
                                              [
                                                _c("dt", [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.$t(
                                                        "MAIN_CONTENT.ClassGrades.classAverage"
                                                      )
                                                    )
                                                  )
                                                ]),
                                                _vm._v(" "),
                                                _c(
                                                  "dd",
                                                  [
                                                    !!assignment.MEAN_POINTS ||
                                                    assignment.MEAN_POINTS === 0
                                                      ? [
                                                          _vm._v(
                                                            "\n\t\t\t\t\t\t\t\t\t\t\t\t" +
                                                              _vm._s(
                                                                assignment.MEAN_POINTS
                                                              ) +
                                                              "\n\t\t\t\t\t\t\t\t\t\t\t"
                                                          )
                                                        ]
                                                      : [
                                                          _vm._v(
                                                            "\n\t\t\t\t\t\t\t\t\t\t\t\t*\n\t\t\t\t\t\t\t\t\t\t\t"
                                                          )
                                                        ]
                                                  ],
                                                  2
                                                )
                                              ]
                                            )
                                          ]
                                        )
                                      : _vm._e(),
                                    _vm._v(" "),
                                    _vm.grades.REPORT_OPTIONS
                                      .SHOW_STUDENT_NUM_HIGHER_FLG === "Y"
                                      ? _c(
                                          "div",
                                          {
                                            staticClass:
                                              "col-xs-6 col-sm-4 col-md-3 col-lg-2 detail-wrapper"
                                          },
                                          [
                                            _c(
                                              "div",
                                              { staticClass: "content" },
                                              [
                                                _c("dt", [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.$t(
                                                        "MAIN_CONTENT.ClassGrades.scoresHigher"
                                                      )
                                                    )
                                                  )
                                                ]),
                                                _vm._v(" "),
                                                _c("dd", [
                                                  _vm._v(
                                                    _vm._s(
                                                      assignment.NUM_HIGHER
                                                    )
                                                  )
                                                ])
                                              ]
                                            )
                                          ]
                                        )
                                      : _vm._e(),
                                    _vm._v(" "),
                                    _vm.grades.REPORT_OPTIONS
                                      .SHOW_STUDENT_NUM_SAME_FLG === "Y"
                                      ? _c(
                                          "div",
                                          {
                                            staticClass:
                                              "col-xs-6 col-sm-4 col-md-3 col-lg-2 detail-wrapper"
                                          },
                                          [
                                            _c(
                                              "div",
                                              { staticClass: "content" },
                                              [
                                                _c("dt", [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.$t(
                                                        "MAIN_CONTENT.ClassGrades.scoresSame"
                                                      )
                                                    )
                                                  )
                                                ]),
                                                _vm._v(" "),
                                                _c("dd", [
                                                  _vm._v(
                                                    _vm._s(assignment.NUM_SAME)
                                                  )
                                                ])
                                              ]
                                            )
                                          ]
                                        )
                                      : _vm._e(),
                                    _vm._v(" "),
                                    _vm.grades.REPORT_OPTIONS
                                      .SHOW_STUDENT_NUM_LOWER_FLG === "Y"
                                      ? _c(
                                          "div",
                                          {
                                            staticClass:
                                              "col-xs-6 col-sm-4 col-md-3 col-lg-2 detail-wrapper"
                                          },
                                          [
                                            _c(
                                              "div",
                                              { staticClass: "content" },
                                              [
                                                _c("dt", [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.$t(
                                                        "MAIN_CONTENT.ClassGrades.scoresLower"
                                                      )
                                                    )
                                                  )
                                                ]),
                                                _vm._v(" "),
                                                _c("dd", [
                                                  _vm._v(
                                                    _vm._s(assignment.NUM_LOWER)
                                                  )
                                                ])
                                              ]
                                            )
                                          ]
                                        )
                                      : _vm._e()
                                  ]
                                ),
                                _vm._v(" "),
                                assignment.ASSIGNMENT_DESC &&
                                _vm.grades.REPORT_OPTIONS
                                  .SHOW_ASSIGNMENT_DESC_FLG === "Y"
                                  ? _c(
                                      "div",
                                      { staticClass: "additional-comments" },
                                      [
                                        _c("h5", [
                                          _c("strong", [
                                            _vm._v(
                                              _vm._s(
                                                _vm.$t(
                                                  "MAIN_CONTENT.ClassGrades.assignmentDescription"
                                                )
                                              )
                                            )
                                          ])
                                        ]),
                                        _vm._v(" "),
                                        _c("p", [
                                          _vm._v(
                                            _vm._s(assignment.ASSIGNMENT_DESC)
                                          )
                                        ])
                                      ]
                                    )
                                  : _vm._e(),
                                _vm._v(" "),
                                assignment.ASSIGNMENT_COMMENTS &&
                                _vm.grades.REPORT_OPTIONS.SHOW_COMMENTS_FLG ===
                                  "Y"
                                  ? _c(
                                      "div",
                                      { staticClass: "additional-comments" },
                                      [
                                        _c("h5", [
                                          _c("strong", [
                                            _vm._v(
                                              _vm._s(
                                                _vm.$t(
                                                  "MAIN_CONTENT.ClassGrades.teacherComments"
                                                )
                                              )
                                            )
                                          ])
                                        ]),
                                        _vm._v(" "),
                                        _c("p", [
                                          _vm._v(
                                            _vm._s(
                                              assignment.ASSIGNMENT_COMMENTS
                                            )
                                          )
                                        ])
                                      ]
                                    )
                                  : _vm._e(),
                                _vm._v(" "),
                                _vm.grades.REPORT_OPTIONS
                                  .SHOW_SKILLS_ASSIGNED === "Y" &&
                                assignment.SKILLS.length > 0
                                  ? _c(
                                      "div",
                                      { staticClass: "additional-comments" },
                                      [
                                        _c("h5", [
                                          _c("strong", [
                                            _vm._v(
                                              "\n\t\t\t\t\t\t\t\t\t\t" +
                                                _vm._s(
                                                  _vm.$t(
                                                    "MAIN_CONTENT.ClassGrades.assignmentSkills"
                                                  )
                                                ) +
                                                "\n\t\t\t\t\t\t\t\t\t"
                                            )
                                          ])
                                        ]),
                                        _vm._v(" "),
                                        _c(
                                          "ul",
                                          {
                                            staticStyle: {
                                              "list-style-type": "none"
                                            }
                                          },
                                          _vm._l(assignment.SKILLS, function(
                                            skill,
                                            skillIndex
                                          ) {
                                            return _c(
                                              "li",
                                              {
                                                key:
                                                  "assignmentSkills_" +
                                                  skillIndex
                                              },
                                              [
                                                _vm._v(
                                                  "\n\t\t\t\t\t\t\t\t\t\t" +
                                                    _vm._s(
                                                      skill.LINE_ITEM_DESC
                                                    ) +
                                                    "\n\t\t\t\t\t\t\t\t\t"
                                                )
                                              ]
                                            )
                                          }),
                                          0
                                        )
                                      ]
                                    )
                                  : _vm._e(),
                                _vm._v(" "),
                                _vm.wasAttempted(assignment)
                                  ? _c(
                                      "div",
                                      {
                                        staticClass: "text-center mb-1",
                                        on: {
                                          click: function($event) {
                                            return _vm.reviewTest(assignment)
                                          }
                                        }
                                      },
                                      [
                                        _c(
                                          "button",
                                          { staticClass: "btn btn-primary" },
                                          [
                                            _vm._v(
                                              "\n\t\t\t\t\t\t\t\t\t" +
                                                _vm._s(
                                                  _vm.$t(
                                                    "MAIN_CONTENT.ClassGrades.viewAssignmentTest"
                                                  )
                                                ) +
                                                "\n\t\t\t\t\t\t\t\t"
                                            )
                                          ]
                                        )
                                      ]
                                    )
                                  : _vm._e()
                              ])
                            ]
                          )
                        ]
                      })
                    ],
                    2
                  )
                : _vm.show === "category"
                ? _c(
                    "div",
                    { staticClass: "display-table by-category mb-1" },
                    [
                      _vm._l(_vm.grades.CATEGORIES, function(category) {
                        return [
                          _vm.assignmentsByCategory(category.CATEGORY_CODE)
                            .length
                            ? _c(
                                "div",
                                {
                                  key: "assignments-" + category.CATEGORY_CODE,
                                  staticClass: "display-container"
                                },
                                [
                                  _c("div", { staticClass: "header" }, [
                                    _c("h4", [
                                      _c("strong", [
                                        _vm._v(_vm._s(category.CATEGORY_NAME))
                                      ])
                                    ])
                                  ]),
                                  _vm._v(" "),
                                  _vm._l(
                                    _vm.assignmentsByCategory(
                                      category.CATEGORY_CODE
                                    ),
                                    function(assignment) {
                                      return _c(
                                        "div",
                                        {
                                          key:
                                            assignment.ASSIGNMENT_CODE +
                                            "-" +
                                            category.CATEGORY_CODE,
                                          staticClass: "details"
                                        },
                                        [
                                          _c(
                                            "div",
                                            {
                                              staticClass:
                                                "sub-header col-xs-12"
                                            },
                                            [
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "col-xs-12 col-sm-6"
                                                },
                                                [
                                                  _c("h5", [
                                                    _vm._v(
                                                      "\n\t\t\t\t\t\t\t\t\t\t" +
                                                        _vm._s(
                                                          assignment.ASSIGNMENT_NAME
                                                        ) +
                                                        "\n\t\t\t\t\t\t\t\t\t"
                                                    )
                                                  ])
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "col-xs-12 col-sm-6 score-pill-height"
                                                },
                                                [
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "score-pill float-right"
                                                    },
                                                    [
                                                      !!_vm.gradeMappings[
                                                        assignment.GRADE_CODE.toString().toUpperCase()
                                                      ]
                                                        ? _c(
                                                            "span",
                                                            {
                                                              directives: [
                                                                {
                                                                  name:
                                                                    "tooltip",
                                                                  rawName:
                                                                    "v-tooltip.top-center",
                                                                  value: {
                                                                    content: _vm.assignmentsTooltip(
                                                                      assignment.GRADE_CODE
                                                                    ),
                                                                    trigger:
                                                                      "hover click"
                                                                  },
                                                                  expression:
                                                                    "{content: assignmentsTooltip(assignment.GRADE_CODE), trigger: 'hover click'}",
                                                                  modifiers: {
                                                                    "top-center": true
                                                                  }
                                                                }
                                                              ]
                                                            },
                                                            [
                                                              _c("i", {
                                                                staticClass:
                                                                  "fas fa-question-circle"
                                                              })
                                                            ]
                                                          )
                                                        : _vm._e(),
                                                      _vm._v(
                                                        " \n\t\t\t\t\t\t\t\t\t\t" +
                                                          _vm._s(
                                                            _vm.$t(
                                                              "MAIN_CONTENT.commonContent.score"
                                                            )
                                                          ) +
                                                          " \n\t\t\t\t\t\t\t\t\t\t"
                                                      ),
                                                      _c(
                                                        "strong",
                                                        [
                                                          _vm.grades
                                                            .REPORT_OPTIONS
                                                            .SHOW_STUDENT_GRADE_PERCENT_FLG ===
                                                          "Y"
                                                            ? [
                                                                _vm._v(
                                                                  "\n\t\t\t\t\t\t\t\t\t\t\t\t" +
                                                                    _vm._s(
                                                                      _vm.$t(
                                                                        "MAIN_CONTENT.ClassGrades.codeOverPointsPercent",
                                                                        {
                                                                          code:
                                                                            assignment.GRADE_CODE,
                                                                          points:
                                                                            assignment.MAX_POINTS,
                                                                          percent:
                                                                            assignment.GRADE_PERCENT
                                                                        }
                                                                      )
                                                                    ) +
                                                                    "\n\t\t\t\t\t\t\t\t\t\t\t"
                                                                )
                                                              ]
                                                            : [
                                                                _vm._v(
                                                                  "\n\t\t\t\t\t\t\t\t\t\t\t\t" +
                                                                    _vm._s(
                                                                      _vm.$t(
                                                                        "MAIN_CONTENT.ClassGrades.codeOverPoints",
                                                                        {
                                                                          code:
                                                                            assignment.GRADE_CODE,
                                                                          points:
                                                                            assignment.MAX_POINTS
                                                                        }
                                                                      )
                                                                    ) +
                                                                    "\n\t\t\t\t\t\t\t\t\t\t\t"
                                                                )
                                                              ]
                                                        ],
                                                        2
                                                      )
                                                    ]
                                                  )
                                                ]
                                              )
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "div",
                                            {
                                              staticClass:
                                                "grades-details flex-container"
                                            },
                                            [
                                              _vm.grades.REPORT_OPTIONS
                                                .SHOW_EXTRA_CREDIT_FLG === "Y"
                                                ? _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "col-xs-6 col-sm-4 col-md-3 col-lg-2 detail-wrapper"
                                                    },
                                                    [
                                                      _c(
                                                        "div",
                                                        {
                                                          staticClass: "content"
                                                        },
                                                        [
                                                          _c("dt", [
                                                            _vm._v(
                                                              _vm._s(
                                                                _vm.$t(
                                                                  "MAIN_CONTENT.ClassGrades.maxExtraCredit"
                                                                )
                                                              )
                                                            )
                                                          ]),
                                                          _vm._v(" "),
                                                          _c("dd", [
                                                            _vm._v(
                                                              _vm._s(
                                                                assignment.MAX_EC_POINTS
                                                              )
                                                            )
                                                          ])
                                                        ]
                                                      )
                                                    ]
                                                  )
                                                : _vm._e(),
                                              _vm._v(" "),
                                              _vm.grades.REPORT_OPTIONS
                                                .SHOW_STUDENT_ASSIGNED_DATE_FLG ===
                                              "Y"
                                                ? _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "col-xs-6 col-sm-4 col-md-3 col-lg-2 detail-wrapper"
                                                    },
                                                    [
                                                      _c(
                                                        "div",
                                                        {
                                                          staticClass: "content"
                                                        },
                                                        [
                                                          _c("dt", [
                                                            _vm._v(
                                                              _vm._s(
                                                                _vm.$t(
                                                                  "MAIN_CONTENT.ClassGrades.dateAssigned"
                                                                )
                                                              )
                                                            )
                                                          ]),
                                                          _vm._v(" "),
                                                          _c("dd", [
                                                            _vm._v(
                                                              _vm._s(
                                                                _vm._f("date")(
                                                                  assignment.START_DATE
                                                                )
                                                              )
                                                            )
                                                          ])
                                                        ]
                                                      )
                                                    ]
                                                  )
                                                : _vm._e(),
                                              _vm._v(" "),
                                              _vm.grades.REPORT_OPTIONS
                                                .SHOW_STUDENT_DUE_DATE_FLG ===
                                              "Y"
                                                ? _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "col-xs-6 col-sm-4 col-md-3 col-lg-2 detail-wrapper",
                                                      class: _vm.dueSoon(
                                                        assignment.END_DATE
                                                      )
                                                        ? "text-danger"
                                                        : ""
                                                    },
                                                    [
                                                      _c(
                                                        "div",
                                                        {
                                                          staticClass: "content"
                                                        },
                                                        [
                                                          _c("dt", [
                                                            _vm._v(
                                                              _vm._s(
                                                                _vm.$t(
                                                                  "MAIN_CONTENT.ClassGrades.dateDue"
                                                                )
                                                              )
                                                            )
                                                          ]),
                                                          _vm._v(" "),
                                                          _c("dd", [
                                                            _vm._v(
                                                              _vm._s(
                                                                _vm._f("date")(
                                                                  assignment.END_DATE
                                                                )
                                                              )
                                                            )
                                                          ])
                                                        ]
                                                      )
                                                    ]
                                                  )
                                                : _vm._e(),
                                              _vm._v(" "),
                                              _vm.grades.REPORT_OPTIONS
                                                .SHOW_STUDENT_CLASS_AVERAGE_FLG ===
                                              "Y"
                                                ? _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "col-xs-6 col-sm-4 col-md-3 col-lg-2 detail-wrapper"
                                                    },
                                                    [
                                                      _c(
                                                        "div",
                                                        {
                                                          staticClass: "content"
                                                        },
                                                        [
                                                          _c("dt", [
                                                            _vm._v(
                                                              _vm._s(
                                                                _vm.$t(
                                                                  "MAIN_CONTENT.ClassGrades.classAverage"
                                                                )
                                                              )
                                                            )
                                                          ]),
                                                          _vm._v(" "),
                                                          _c(
                                                            "dd",
                                                            [
                                                              !!assignment.MEAN_POINTS ||
                                                              assignment.MEAN_POINTS ===
                                                                0
                                                                ? [
                                                                    _vm._v(
                                                                      "\n\t\t\t\t\t\t\t\t\t\t\t\t" +
                                                                        _vm._s(
                                                                          assignment.MEAN_POINTS
                                                                        ) +
                                                                        "\n\t\t\t\t\t\t\t\t\t\t\t"
                                                                    )
                                                                  ]
                                                                : [
                                                                    _vm._v(
                                                                      "\n\t\t\t\t\t\t\t\t\t\t\t\t*\n\t\t\t\t\t\t\t\t\t\t\t"
                                                                    )
                                                                  ]
                                                            ],
                                                            2
                                                          )
                                                        ]
                                                      )
                                                    ]
                                                  )
                                                : _vm._e(),
                                              _vm._v(" "),
                                              _vm.grades.REPORT_OPTIONS
                                                .SHOW_STUDENT_NUM_HIGHER_FLG ===
                                              "Y"
                                                ? _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "col-xs-6 col-sm-4 col-md-3 col-lg-2 detail-wrapper"
                                                    },
                                                    [
                                                      _c(
                                                        "div",
                                                        {
                                                          staticClass: "content"
                                                        },
                                                        [
                                                          _c("dt", [
                                                            _vm._v(
                                                              _vm._s(
                                                                _vm.$t(
                                                                  "MAIN_CONTENT.ClassGrades.scoresHigher"
                                                                )
                                                              )
                                                            )
                                                          ]),
                                                          _vm._v(" "),
                                                          _c("dd", [
                                                            _vm._v(
                                                              _vm._s(
                                                                assignment.NUM_HIGHER
                                                              )
                                                            )
                                                          ])
                                                        ]
                                                      )
                                                    ]
                                                  )
                                                : _vm._e(),
                                              _vm._v(" "),
                                              _vm.grades.REPORT_OPTIONS
                                                .SHOW_STUDENT_NUM_SAME_FLG ===
                                              "Y"
                                                ? _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "col-xs-6 col-sm-4 col-md-3 col-lg-2 detail-wrapper"
                                                    },
                                                    [
                                                      _c(
                                                        "div",
                                                        {
                                                          staticClass: "content"
                                                        },
                                                        [
                                                          _c("dt", [
                                                            _vm._v(
                                                              _vm._s(
                                                                _vm.$t(
                                                                  "MAIN_CONTENT.ClassGrades.scoresSame"
                                                                )
                                                              )
                                                            )
                                                          ]),
                                                          _vm._v(" "),
                                                          _c("dd", [
                                                            _vm._v(
                                                              _vm._s(
                                                                assignment.NUM_SAME
                                                              )
                                                            )
                                                          ])
                                                        ]
                                                      )
                                                    ]
                                                  )
                                                : _vm._e(),
                                              _vm._v(" "),
                                              _vm.grades.REPORT_OPTIONS
                                                .SHOW_STUDENT_NUM_LOWER_FLG ===
                                              "Y"
                                                ? _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "col-xs-6 col-sm-4 col-md-3 col-lg-2 detail-wrapper"
                                                    },
                                                    [
                                                      _c(
                                                        "div",
                                                        {
                                                          staticClass: "content"
                                                        },
                                                        [
                                                          _c("dt", [
                                                            _vm._v(
                                                              _vm._s(
                                                                _vm.$t(
                                                                  "MAIN_CONTENT.ClassGrades.scoresLower"
                                                                )
                                                              )
                                                            )
                                                          ]),
                                                          _vm._v(" "),
                                                          _c("dd", [
                                                            _vm._v(
                                                              _vm._s(
                                                                assignment.NUM_LOWER
                                                              )
                                                            )
                                                          ])
                                                        ]
                                                      )
                                                    ]
                                                  )
                                                : _vm._e()
                                            ]
                                          ),
                                          _vm._v(" "),
                                          assignment.ASSIGNMENT_DESC
                                            ? _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "additional-comments"
                                                },
                                                [
                                                  _c("h5", [
                                                    _c("strong", [
                                                      _vm._v(
                                                        _vm._s(
                                                          _vm.$t(
                                                            "MAIN_CONTENT.ClassGrades.assignmentDescription"
                                                          )
                                                        )
                                                      )
                                                    ])
                                                  ]),
                                                  _vm._v(" "),
                                                  _c("p", [
                                                    _vm._v(
                                                      _vm._s(
                                                        assignment.ASSIGNMENT_DESC
                                                      )
                                                    )
                                                  ])
                                                ]
                                              )
                                            : _vm._e(),
                                          _vm._v(" "),
                                          assignment.ASSIGNMENT_COMMENTS &&
                                          _vm.grades.REPORT_OPTIONS
                                            .SHOW_COMMENTS_FLG === "Y"
                                            ? _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "additional-comments"
                                                },
                                                [
                                                  _c("h5", [
                                                    _c("strong", [
                                                      _vm._v(
                                                        _vm._s(
                                                          _vm.$t(
                                                            "MAIN_CONTENT.ClassGrades.teacherComments"
                                                          )
                                                        )
                                                      )
                                                    ])
                                                  ]),
                                                  _vm._v(" "),
                                                  _c("p", [
                                                    _vm._v(
                                                      _vm._s(
                                                        assignment.ASSIGNMENT_COMMENTS
                                                      )
                                                    )
                                                  ])
                                                ]
                                              )
                                            : _vm._e(),
                                          _vm._v(" "),
                                          _vm.grades.REPORT_OPTIONS
                                            .SHOW_SKILLS_ASSIGNED === "Y" &&
                                          assignment.SKILLS.length > 0
                                            ? _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "additional-comments"
                                                },
                                                [
                                                  _c("h5", [
                                                    _c("strong", [
                                                      _vm._v(
                                                        "\n\t\t\t\t\t\t\t\t\t\t" +
                                                          _vm._s(
                                                            _vm.$t(
                                                              "MAIN_CONTENT.ClassGrades.assignmentSkills"
                                                            )
                                                          ) +
                                                          "\n\t\t\t\t\t\t\t\t\t"
                                                      )
                                                    ])
                                                  ]),
                                                  _vm._v(" "),
                                                  _c(
                                                    "ul",
                                                    {
                                                      staticStyle: {
                                                        "list-style-type":
                                                          "none"
                                                      }
                                                    },
                                                    _vm._l(
                                                      assignment.SKILLS,
                                                      function(
                                                        skill,
                                                        skillIndex
                                                      ) {
                                                        return _c(
                                                          "li",
                                                          {
                                                            key:
                                                              "assignmentSkills_" +
                                                              skillIndex
                                                          },
                                                          [
                                                            _vm._v(
                                                              "\n\t\t\t\t\t\t\t\t\t\t" +
                                                                _vm._s(
                                                                  skill.LINE_ITEM_DESC
                                                                ) +
                                                                "\n\t\t\t\t\t\t\t\t\t"
                                                            )
                                                          ]
                                                        )
                                                      }
                                                    ),
                                                    0
                                                  )
                                                ]
                                              )
                                            : _vm._e(),
                                          _vm._v(" "),
                                          _vm.wasAttempted(assignment)
                                            ? _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "text-center mb-1",
                                                  on: {
                                                    click: function($event) {
                                                      return _vm.reviewTest(
                                                        assignment
                                                      )
                                                    }
                                                  }
                                                },
                                                [
                                                  _c(
                                                    "button",
                                                    {
                                                      staticClass:
                                                        "btn btn-primary"
                                                    },
                                                    [
                                                      _vm._v(
                                                        "\n\t\t\t\t\t\t\t\t\t" +
                                                          _vm._s(
                                                            _vm.$t(
                                                              "MAIN_CONTENT.ClassGrades.viewAssignmentTest"
                                                            )
                                                          ) +
                                                          "\n\t\t\t\t\t\t\t\t"
                                                      )
                                                    ]
                                                  )
                                                ]
                                              )
                                            : _vm._e()
                                        ]
                                      )
                                    }
                                  )
                                ],
                                2
                              )
                            : _vm._e()
                        ]
                      })
                    ],
                    2
                  )
                : _vm._e()
            ]),
            _vm._v(" "),
            _vm.grades.REPORT_OPTIONS.SHOW_SKILL_GRADES_FLG === "Y" &&
            _vm.grades.SKILLS.length > 0
              ? _c("div", { staticClass: "display-table skill-grades" }, [
                  _c("table", { staticClass: "table table-box" }, [
                    _c("thead", [
                      _c("tr", [
                        _c("th", [
                          _vm._v(
                            _vm._s(_vm.$t("MAIN_CONTENT.ClassGrades.skill"))
                          )
                        ]),
                        _vm._v(" "),
                        _c("th", [
                          _vm._v(
                            _vm._s(
                              _vm.$t(
                                "MAIN_CONTENT.ClassGrades.currentGradeTitleCase"
                              )
                            )
                          )
                        ])
                      ])
                    ]),
                    _vm._v(" "),
                    _c(
                      "tbody",
                      _vm._l(_vm.grades.SKILLS, function(skill, i) {
                        return _c("tr", { key: i }, [
                          _c("td", [_vm._v(_vm._s(skill.SKILL_DESCRIPTION))]),
                          _vm._v(" "),
                          _c("td", [_vm._v(_vm._s(skill.SKILL_GRADE))])
                        ])
                      }),
                      0
                    )
                  ])
                ])
              : _vm._e(),
            _vm._v(" "),
            _vm.grades.REPORT_OPTIONS.SHOW_GENERAL_COMMENTS_FLG === "Y"
              ? _c("div", { staticClass: "display-table general-comment" }, [
                  _c("div", { staticClass: "display-container" }, [
                    _c("div", { staticClass: "details" }, [
                      _c("div", { staticClass: "sub-header col-xs-12" }, [
                        _c("h4", [
                          _vm._v(
                            _vm._s(
                              _vm.$t("MAIN_CONTENT.ClassGrades.generalComment")
                            )
                          )
                        ])
                      ]),
                      _vm._v(" "),
                      _c("p", [_vm._v(_vm._s(_vm.grades.GENERAL_COMMENTS))])
                    ])
                  ])
                ])
              : _vm._e()
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "back-link" }, [
            _c(
              "a",
              {
                staticStyle: { cursor: "pointer" },
                on: {
                  click: function($event) {
                    return _vm.goToClassPage()
                  }
                }
              },
              [
                _c("i", {
                  staticClass: "fas fa-caret-left",
                  attrs: { "aria-hidden": "true" }
                }),
                _vm._v(
                  _vm._s(_vm.$t("MAIN_CONTENT.commonContent.goBack")) + "\n\t\t"
                )
              ]
            )
          ])
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }